/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type FileInputFieldQueryVariables = {
    slug?: string | null;
};
export type FileInputFieldQueryResponse = {
    readonly attachmentQuery: {
        readonly url: string;
        readonly name: string | null;
        readonly previewUrl: string | null;
        readonly contentType: string;
    } | null;
};
export type FileInputFieldQuery = {
    readonly response: FileInputFieldQueryResponse;
    readonly variables: FileInputFieldQueryVariables;
};



/*
query FileInputFieldQuery(
  $slug: String
) {
  attachmentQuery(slug: $slug) {
    url
    name
    previewUrl
    contentType
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "Attachment",
    "kind": "LinkedField",
    "name": "attachmentQuery",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previewUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contentType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileInputFieldQuery",
    "selections": (v1/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileInputFieldQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "21ab3ceb11f4099bc24b577137a2aa30",
    "id": null,
    "metadata": {},
    "name": "FileInputFieldQuery",
    "operationKind": "query",
    "text": "query FileInputFieldQuery(\n  $slug: String\n) {\n  attachmentQuery(slug: $slug) {\n    url\n    name\n    previewUrl\n    contentType\n  }\n}\n"
  }
};
})();
(node as any).hash = '9642036fea6dee5d5408b176aa8bb94d';
export default node;
